import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { PendingTermsOfServiceSignatureService } from './pending-terms-of-service-signature.service';
import { PendingTermsOfServiceSignatureComponent } from './pending-terms-of-service-signature.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FuseSharedModule } from '../../../../@fuse/shared.module';

// AppModule imports this module, so it is in the initial bundle: single Material modules only. (VS-1961)
@NgModule({
    declarations: [PendingTermsOfServiceSignatureComponent],
    imports: [CommonModule, MatButtonModule, MatDialogModule, MatIconModule, FuseSharedModule, TranslocoModule],
    providers: [PendingTermsOfServiceSignatureService],
    exports: [PendingTermsOfServiceSignatureComponent],
})
export class PendingTermsOfServiceSignatureModule {}
